import React, { useState } from "react";

import tickDoctor from "assets/tickDoctor.png";
import { Avatar, Badge, Skeleton, styled } from "@mui/material";

const CheckIcon = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(2.12),
  height: theme.spacing(2.12),
  background: "#D91A5F",
  padding: theme.spacing(0.62),
}));

const NotCheck = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(2.12),
  height: theme.spacing(2.12),
  background: "#ffffff",
  border: "1px solid #DEDDDD",
}));

const DoctorImg = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(11.5),
  height: theme.spacing(11.5),
}));

const DoctorImgSel = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(11.5),
  height: theme.spacing(11.5),
  border: "2px solid #D91A5F",
}));

const AllAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(11.5),
  height: theme.spacing(11.5),
  fontWeight: 700,
  background: "white",
  color: "#02CCCC",
}));

const AllAvatarSel = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(11.5),
  height: theme.spacing(11.5),
  fontWeight: 700,
  background: "white",
  color: "#02CCCC",
  border: "2px solid #D91A5F",
}));

const DoctorIconList = (props) => {
  const { selected, setSelected } = props;
  const [selectedDoctor, setSelectedDoctor] = useState(-1);

  const onClickAll = () => {
    setSelected("all");
    setSelectedDoctor(-1);
  };

  const onClickIcon = (id, index) => {
    setSelected(id);
    setSelectedDoctor(index);
  };

  if (props.type === null) {
    return (
      <div className="dashboard-dr-list">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i, index) => (
          <div key={index} className="dr-circle" style={{ marginBottom: 30 }}>
            <Skeleton
              animation="wave"
              variant="circle"
              width={86}
              height={86}
            />
            <Skeleton animation="wave" />
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="dashboard-dr-list">
      <div
        onClick={onClickAll}
        className="dr-circle"
        style={{ cursor: "pointer" }}
      >
        <Badge
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          badgeContent={
            selectedDoctor === -1 ? (
              <CheckIcon src={tickDoctor} />
            ) : (
              <NotCheck />
            )
          }
        >
          {selectedDoctor === -1 ? (
            <AllAvatarSel>ALL</AllAvatarSel>
          ) : (
            <AllAvatar>ALL</AllAvatar>
          )}
        </Badge>
        <br />{" "}
      </div>
      {props.type &&
        props.type.map((d, index) => (
          <div
            key={index}
            className="dr-circle"
            onClick={() => onClickIcon(d.id, index)}
            style={{ cursor: "pointer" }}
          >
            <Badge
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              badgeContent={
                selectedDoctor === index ? (
                  <CheckIcon src={tickDoctor} />
                ) : (
                  <NotCheck></NotCheck>
                )
              }
            >
              {selectedDoctor === index ? (
                <DoctorImgSel>{d.shortName}</DoctorImgSel>
              ) : (
                <DoctorImg>{d.shortName}</DoctorImg>
              )}
            </Badge>
            <br />
            <p className="dr-name">{d.name}</p>
          </div>
        ))}
    </div>
  );
};

export default DoctorIconList;
